module.exports = __webpack_public_path__ + "img/start-128.aa3d2bea.png";